import { useContext } from "react";
import { useParams } from "react-router-dom";
import { getById } from "sprint-common-web";

import { DeliveryEndpointType } from "../../../../common/types/DeliveryEndpointType";
import { useAdminDeliveryEndpointApi } from "../../api/useAdminDeliveryEndpointApi";
import { useSigniantStorageEndpoints } from "../../common/useSigniantStorageEndpoints";
import { DeliveryEndpointContext } from "../../context/DeliveryEndpointContext";
import { CreateDeliveryEndpointFormInputs } from "./CreateSigniantDeliveryEndpointForm";

export const useCreateSigniantDeliveryEndpointForm = () => {
    const { createDeliveryEndpoint } = useAdminDeliveryEndpointApi();
    const { storageProfiles, isLoading } = useSigniantStorageEndpoints();

    const { addSigniantDeliveryEndpointItem } = useContext(DeliveryEndpointContext);

    const { integratorId } = useParams<{ integratorId: string }>();

    const addDeliveryEndpoint = async ({
        name,
        profileId,
        distributionEmail
    }: CreateDeliveryEndpointFormInputs): Promise<void> => {
        const destinationStorageProfile = getById(storageProfiles, profileId);
        const { entityId } = await createDeliveryEndpoint({
            integratorId,
            name,
            destinationStorageProfile: destinationStorageProfile,
            type: DeliveryEndpointType.Signiant,
            distributionEmail
        });

        addSigniantDeliveryEndpointItem({
            id: entityId,
            name,
            details: { type: DeliveryEndpointType.Signiant, destinationStorageProfile, distributionEmail },
            type: DeliveryEndpointType.Signiant,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        addDeliveryEndpoint,
        storageProfiles: storageProfiles,
        isLoading
    };
};
